module.exports = __webpack_public_path__ + "img/stena11.e242d017.jpg";